import React from 'react';

/**
 * Shell icons — 24px stroke icons matching the redesign mock.
 * All inherit currentColor; size via CSS on the svg element.
 */

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const HomeIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M3 10.5 12 3l9 7.5" />
    <path d="M5.5 9.5V20h13V9.5" />
  </svg>
);

export const SimulateIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="7" cy="16" r="2.4" />
    <circle cx="12.5" cy="8" r="3.2" />
    <circle cx="18" cy="15" r="1.8" />
  </svg>
);

export const IntelIcon = (props) => (
  <svg {...base} {...props}>
    <circle cx="10.5" cy="10.5" r="6.5" />
    <path d="m20 20-4.8-4.8" />
  </svg>
);

export const BuilderIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 8h13" />
    <path d="m14 4 4 4-4 4" />
    <path d="M20 16H7" />
    <path d="m10 12-4 4 4 4" />
  </svg>
);

export const RmtIcon = (props) => (
  <svg {...base} {...props}>
    <path d="m4 7 2 2 3.5-3.5" />
    <path d="M13 7.5h7" />
    <path d="m4 15 2 2 3.5-3.5" />
    <path d="M13 15.5h7" />
  </svg>
);

export const MarketIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M20.6 9.4 12 18l-7.6-7.6V4h6.4l9.8 9.8z" transform="rotate(8 12 11)" />
    <circle cx="8.3" cy="7.8" r="1.3" />
  </svg>
);

export const AnalystIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 2a4 4 0 1 1 0 8 4 4 0 0 1 0-8z" />
    <path d="M3 20c0-4 4-7 9-7s9 3 9 7" />
    <path d="M16 11h5M18.5 8.5l2.5 2.5-2.5 2.5" />
  </svg>
);

export const ReviewIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);

export const CurveIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M3 17c3.5 0 4.5-7 8-7 2.5 0 3.5 3.5 6 3.5" />
    <circle cx="19.5" cy="12.6" r="1.7" fill="currentColor" stroke="none" />
  </svg>
);

export const ArenaIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M5 19 12 5l7 14" />
    <path d="M8.5 14h7" />
    <circle cx="12" cy="19" r="1.2" fill="currentColor" stroke="none" />
  </svg>
);

export const ChevronLeftIcon = (props) => (
  <svg {...base} {...props}>
    <path d="m14 7-5 5 5 5" />
  </svg>
);

export const ChevronRightIcon = (props) => (
  <svg {...base} strokeWidth={2} {...props}>
    <path d="m9 6 6 6-6 6" />
  </svg>
);

export const ChevronDownIcon = (props) => (
  <svg {...base} strokeWidth={2.4} {...props}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const RailToggleIcon = (props) => (
  <svg {...base} {...props}>
    <rect x="3" y="4" width="18" height="16" rx="3" />
    <path d="M15 4v16" />
  </svg>
);

export const StocksIcon = (props) => (
  <svg {...base} {...props}>
    <path d="M4 20V4" />
    <path d="M4 16.5 9 11l3.5 3L18 7.5" />
    <path d="M14.5 7.5H18V11" />
  </svg>
);
